import {useContext} from 'react'

import {toCapitalCase} from '@s-ui/js/lib/string'
import Context from '@s-ui/react-context'
import IconChatLinesOutline from '@adv-mt/mt-svg-icons/lib/ChatLinesOutline'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {LOADING, MediaImage, OBJECT_FIT} from '@adv-mt/ui/media-image'
import {Panel, PANEL_COLORS, PANEL_ELEVATION, PANEL_ROUNDED} from '@adv-mt/ui/panel'
import {Tag, TAG_SIZES, TAG_USAGES} from '@adv-mt/ui/tag'
import {Body1, Body2} from '@adv-mt/ui/typography'

import LinkFactory from '../../../../../../components/LinkFactory/index.js'
import {BASE_CLASS, newsItemShape} from './config.js'

const NewsCard = ({item}) => {
  const {i18n} = useContext(Context)
  const {comments, img, tag, title, url} = item

  const onClickTag = () => {
    window.location.href = tag.url
  }

  return (
    <Panel
      color={PANEL_COLORS.BASE}
      elevation={PANEL_ELEVATION.S}
      rounded={PANEL_ROUNDED.M}
      className={`${BASE_CLASS}-card`}
    >
      <div className={`${BASE_CLASS}-cardMedia`}>
        <MediaImage
          src={img}
          alt=""
          objectFit={OBJECT_FIT.COVER}
          loading={LOADING.LAZY}
          className={`${BASE_CLASS}-cardMediaImage`}
        />
      </div>
      <div className={`${BASE_CLASS}-cardInfo`}>
        {/* Title link first in the DOM so the card is the first tab stop; the tag is moved above it with CSS. */}
        <LinkFactory href={url} className={`${BASE_CLASS}-cardTitleLink`}>
          <Body1 as="p" highlight className={`${BASE_CLASS}-cardTitle`}>
            {title}
          </Body1>
        </LinkFactory>
        {tag?.text && (
          <Tag
            onClick={onClickTag}
            usage={TAG_USAGES.EDITORIAL}
            color={tag.id}
            size={TAG_SIZES.SMALL}
            className={`${BASE_CLASS}-cardTag`}
          >
            {toCapitalCase(tag.text)}
          </Tag>
        )}
      </div>

      <div className={`${BASE_CLASS}-cardFooter`}>
        {Boolean(comments?.count) && (
          <LinkFactory
            href={comments.url}
            aria-label={i18n.t('COMMON.PLURALS.COMMENTS_COUNT', comments.count)}
            className={`${BASE_CLASS}-cardCommentsLink`}
          >
            <Icon size={ICON_SIZES.MD}>
              <IconChatLinesOutline size={ICON_SIZES.MD} />
            </Icon>
            <Body2 as="span" highlight className={`${BASE_CLASS}-cardCommentsCount`}>
              {comments.count}
            </Body2>
          </LinkFactory>
        )}
      </div>
    </Panel>
  )
}

NewsCard.displayName = 'NewsCard'
NewsCard.propTypes = {
  item: newsItemShape.isRequired
}

export default NewsCard
